import { Stack, Text } from "@mantine/core"
import { IconCheck, IconX } from "@tabler/icons-react"
import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import styles from "~/assets/css/StandardCell.module.css"
import { Badge } from "~/components/Badge"
import { isStandardCompliant } from "~/pages/Brand/Products/List/Services/standardCompliance"

interface Props {
  value: LibraryResponses.ProductStandard | undefined
  onClick: (standard: LibraryResponses.ProductStandard) => void
}
export const StandardCell = ({ value, onClick }: Props) => {
  const { t } = useTranslation("certificates")

  if (!value)
    return (
      <Text ml="sm" c="gray">
        -
      </Text>
    )

  return (
    <Stack>
      <Button
        onClick={() => onClick(value)}
        w="max-content"
        bg="none"
        p="0"
        className={styles.standardCell}
      >
        {isStandardCompliant(value) ? (
          <Badge
            text={t("standard.badge.compliant")}
            color="var(--mantine-color-green-6)"
            icon={<IconCheck size={16} />}
            isShort={true}
          />
        ) : (
          <Badge
            text={t("standard.badge.notCompliant")}
            color="var(--mantine-color-red-6)"
            icon={<IconX size={16} />}
            isShort={true}
          />
        )}
      </Button>
    </Stack>
  )
}
